<template>
  <div>
    <pre v-if="rendered" v-highlightjs="item.code" class="code"><code :class="item.language"></code></pre>
    <div v-else class="code">{{ item.code }}</div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import crypto from 'crypto';

  export default {
    name: 'Code',
    props: ['item', 'path', 'data', 'page'],
    data() {
      return {
        editing: false,
        rendered: false
      }
    },
    components: {
    },
    mounted() {
      this.renderPage()
    },
    methods: {
      makeHashId: function(obj) {
        return crypto.createHash('md5').update(JSON.stringify(obj)).digest('hex')
      },

      change: function (event) {
        if (this.editing) {
          this.item.text = this.$refs[this.path.join('.')].value
          this.updatePage(this.page)
        }
        this.editing = !this.editing
      },
      renderPage: function () {
        setTimeout(() => this.rendered = true, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .code {
    overflow: scroll;
    max-width: 100%;
  }
</style>

